var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2638 11.983L17.6681 8.57872C18.1106 8.17021 18.1106 7.48936 17.6681 7.08085L16.9191 6.33191C16.5106 5.88936 15.8298 5.88936 15.4213 6.33191L12.017 9.73617L8.57872 6.33191C8.17021 5.88936 7.48936 5.88936 7.08085 6.33191L6.33191 7.08085C5.88936 7.48936 5.88936 8.17021 6.33191 8.57872L9.73617 11.983L6.33191 15.4213C5.88936 15.8298 5.88936 16.5106 6.33191 16.9191L7.08085 17.6681C7.48936 18.1106 8.17021 18.1106 8.57872 17.6681L12.017 14.2638L15.4213 17.6681C15.8298 18.1106 16.5106 18.1106 16.9191 17.6681L17.6681 16.9191C18.1106 16.5106 18.1106 15.8298 17.6681 15.4213L14.2638 11.983Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a94a16e1780287e63509108bc4c2ad7f.svg";
export { ForwardRef as ReactComponent };